import { atom } from "jotai";

export const timestampsAtom = atom(() => {
	const now = new Date();
	const start = new Date(now.getTime() - 24 * 60 * 60 * 1000);
	return { start_datetime: start, end_datetime: now };
});
